import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const Header: React.FC<{
  title: string;
  onAdd?: () => void;
  addLabel?: string;
  showBack?: boolean;
  addButtonDisabled?: boolean;
  addButtonTooltip?: string;
}> = ({
  title,
  onAdd,
  addLabel,
  showBack,
  addButtonDisabled,
  addButtonTooltip,
}) => {
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <header className="font-body tracking-wider w-full flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            className="px-2 py-1 border rounded-md hover:bg-gray-100"
          >
            ← Back
          </button>
        )}

        <h1 className="text-md md:text-2xl font-bold tracking-tight">
          {title}
        </h1>
      </div>

      {addLabel && (
        <button
          onClick={addButtonDisabled ? undefined : onAdd}
          disabled={addButtonDisabled}
          className={`px-3 py-2 rounded-md flex items-center gap-2 text-sm ${
            addButtonDisabled
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
          title={addButtonTooltip}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
          {addLabel}
        </button>
      )}
    </header>
  );
};
